function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, fileName) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-file-uploader-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": {
            type: `text`,
            disabled: true,
            value: fileName,
            placeholder: $attr(`placeholder`),
          },
          "class": {
            'mp-file-uploader-file-name': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-file-uploader-alignment-pipe': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("label", {
          "class": {
            'mp-file-uploader-upload-button': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("" + ($attr(`label`)) + "");
          __jade_nodes = __jade_nodes.concat(h("input", {
            "attrs": {
              type: `file`,
              accept: $attr(`accept`)
            },
            "on": {
              change: $helpers.toggleFileChange
            },
            "class": {
              'mp-file-uploader-file-input': true
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "fileName" in locals ? locals.fileName : typeof fileName !== "undefined" ? fileName : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;